export default "__VITE_ASSET__Cc$Z9NA6__"